module.exports = __webpack_public_path__ + "img/Opplysningstid_Andre_kunstformer5.1686ac7e.jpg";